// extracted by mini-css-extract-plugin
module.exports = {"singleLine":"Underline_singleLine___Z_hr","multiLine":"Underline_multiLine__8rRD7","svgUnderline":"Underline_svgUnderline__AVfFY"};